module.exports = __webpack_public_path__ + "static/grafika1@2x-9fba56b7b77759f0d9e4d073e1af1532.png";